import { CSSProperties, ReactNode } from "react"
import { colors } from "../../../services/config/colors"

const Text = ({
  children,
  fontSize = 20,
  fontWeight = 300,
  lineHeight,
  color = colors.text,
  width,
  textAlign = "left",
  style,
  paddingLeft = 0,
  paddingRight = 0,
  ellipsis = false,
  component = "p",
  id,
  ariaHidden = false,
  ariaLabel,
  ariaLive = "off",
}: {
  children?: ReactNode
  fontSize?: number
  fontWeight?: 300 | 400 | 500 | 600 | 700 | 800
  lineHeight?: string
  color?: string
  width?: string | number
  textAlign?: "left" | "center" | "right"
  style?: CSSProperties
  paddingLeft?: number
  paddingRight?: number
  ellipsis?: boolean
  component?: "p" | "h1" | "h2"
  id?: string
  ariaHidden?: boolean
  ariaLabel?: string
  ariaLive?: "assertive" | "polite" | "off"
}) => {
  switch (component) {
    case "p":
      return (
        <p
          id={id}
          style={{
            fontSize: `${fontSize * 0.063}rem`,
            fontWeight: fontWeight,
            lineHeight: lineHeight,
            color: color,
            maxWidth: width,
            textAlign: textAlign,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            whiteSpace: ellipsis ? "nowrap" : undefined,
            overflow: ellipsis ? "hidden" : undefined,
            textOverflow: ellipsis ? "ellipsis" : undefined,
            ...style,
          }}
          aria-hidden={ariaHidden ? "true" : "false"}
          aria-label={ariaLabel}
          aria-live={ariaLive}
        >
          {children}
        </p>
      )
    case "h1":
      return (
        <h1
          id={id}
          style={{
            fontSize: `${fontSize * 0.063}rem`,
            fontWeight: fontWeight,
            lineHeight: lineHeight,
            color: color,
            maxWidth: width,
            textAlign: textAlign,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            whiteSpace: ellipsis ? "nowrap" : undefined,
            overflow: ellipsis ? "hidden" : undefined,
            textOverflow: ellipsis ? "ellipsis" : undefined,
            ...style,
          }}
          aria-hidden={ariaHidden ? "true" : "false"}
          aria-label={ariaLabel}
          aria-live={ariaLive}
        >
          {children}
        </h1>
      )
    case "h2":
      return (
        <h2
          id={id}
          style={{
            fontSize: `${fontSize * 0.063}rem`,
            fontWeight: fontWeight,
            lineHeight: lineHeight,
            color: color,
            maxWidth: width,
            textAlign: textAlign,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            whiteSpace: ellipsis ? "nowrap" : undefined,
            overflow: ellipsis ? "hidden" : undefined,
            textOverflow: ellipsis ? "ellipsis" : undefined,
            ...style,
          }}
          aria-hidden={ariaHidden ? "true" : "false"}
          aria-label={ariaLabel}
          aria-live={ariaLive}
        >
          {children}
        </h2>
      )
  }
}

export default Text
